<template>
  <div>
    <div class="contract-container">
      <div>
        <div class="summary white-box mb-3">
          <h2>Suivi des contrats</h2>
          <div class="chart">
            <canvas id="contract-chart" width="280" height="280"></canvas>
            <span v-if="contractDatas.length > 0" class="total">{{filteredDatas.length}}</span>
          </div>
          <div class="d-flex align-items-center">
            <span class="contract-status-circle-1 inline"></span>
            {{filteredDatas.filter(row => row.ContractStatus == 1).length}}
            à faire
            ({{((filteredDatas.filter(row => row.ContractStatus == 1).length / filteredDatas.length) *100).toFixed(1)}}%)
          </div>
          <div class="d-flex align-items-center">
            <span class="contract-status-circle-2 inline"></span>
            {{filteredDatas.filter(row => row.ContractStatus == 2).length}}
            en négo
            ({{((filteredDatas.filter(row => row.ContractStatus == 2).length / filteredDatas.length) *100).toFixed(1)}}%)
          </div>
          <div class="d-flex align-items-center">
            <span class="contract-status-circle-3 inline"></span>
            {{filteredDatas.filter(row => row.ContractStatus == 3).length}}
            terminés
            ({{((filteredDatas.filter(row => row.ContractStatus == 3).length / filteredDatas.length) *100).toFixed(1)}}%)
          </div>
        </div>
        <div class="shortcuts white-box">
          <h2>Raccourcis</h2>
          <ul>
            <li>
              <a :href="contratShortcutUrl" target="_blank">
                <div class="icon-container" style="background-color: #7ED321;">
                  <font-awesome-icon icon="plane" class="icon" />
                </div>
                Contrats
              </a>
            </li>
            <li>
              <router-link to="/fiche-frs" target="_blank">
                <div class="icon-container" style="background-color: #50E3C2;">
                  <font-awesome-icon icon="calendar-week" class="icon" />
                </div>
                Fiche Suivi RDV
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="details white-box">
        <h2>Détail des contrats</h2>
        <div class="legend">
          <div :class="{active: activeLegend[0]}" @click="toggleActiveLegend(0)">A faire</div>
          <div :class="{active: activeLegend[1]}" @click="toggleActiveLegend(1)">En négo</div>
          <div :class="{active: activeLegend[2]}" @click="toggleActiveLegend(2)">Terminé</div>
        </div>
        <vue-good-table class="card-table"
                        ref="table"
                        @on-column-filter="columnFiltered"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                                        enabled: true,
                                        rowsPerPageLabel: 'Lignes par page',
                                        ofLabel: 'sur',
                                        nextLabel: 'Suivant',
                                        prevLabel: 'Précédent',
                                        allLabel: 'Toutes'
                                    }"
                        :sort-options="{
                                        enabled: true,
                                        multipleColumns: true,
                                        initialSortBy: {field: 'Name', type: 'asc'}
                                      }"
                        compactMode>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'ContractStatus'" :class="'contract-status-circle-' + props.row.ContractStatus">
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import Chart from "chart.js";
  import { uniq } from "@/utils"
  import { getFrsList, getFrsListAdminAll, getFrsContractState, getFrsRubriques, getFrsRubriqueDocuments } from "@/utils/frs";
  import { getIntraRedirectUrl } from "@/helpers/getRedirectUrlHelper";

  export default {
    name: "Contrats",
    props: ["year"],
    data() {
      return {
        chart: null,
        activeLegend: [true, true, true],
        contractDatas: [],
        filteredDatas: [],
        filteredDatasInit: -1,
        frsList: [],
      };
    },
    mounted() {
      this.showChart();
      this.initData();
    },
    watch: {
      $route() {
        this.showChart();
      },
      periodId() {
        this.initData();
      },
      contractDatas() {
        this.showChart();
      }
    },
    methods: {
      columnFiltered() {
        Vue.nextTick(() => {
          const table = this.$refs.table;
          if (table && table.filteredRows && table.filteredRows.length > 0 && table.filteredRows[0] && table.filteredRows[0].children) {
            this.filteredDatas = table.filteredRows[0].children;
            this.showChart();
          }
        })
      },
      formatDate(dateStr) {
        let dateObj = new Date(dateStr);
        return (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate() + "/" +
          ((dateObj.getMonth() + 1) < 10 ? "0" : "") + (dateObj.getMonth() + 1) + "/" +
          dateObj.getFullYear() + " " +
          (dateObj.getHours() < 10 ? "0" : "") + dateObj.getHours() + ":" +
          (dateObj.getMinutes() < 10 ? "0" : "") + dateObj.getMinutes()
      },
      contractStatusToCategory(status) { // On catégorise les contrats en fonction de leur statut
        if (status == -1 || status == 1 || status == 2) return 1;
        if (status == 8) return 3;
        return 2;
      },
      initData() {
        if (this.frsList.length == 0) {
          getFrsList(this.year == -1 ? null : this.year).then(res => {
            this.frsList = res;
          });
        }

        if (this.periodId == -1) return;

        getFrsContractState(this.periodId).then(res => {
          this.contractDatas = res
            .map(row => ({ ...row, ContractStatus: this.contractStatusToCategory(row.ContractStatus) }))
            .sort((a, b) => a.Name < b.Name ? -1 : 1);
          if (this.filteredDatasInit != this.periodId) {
            this.filteredDatasInit = this.periodId;
            Vue.nextTick(() => {
              const table = this.$refs.table;
              if (table && table.filteredRows && table.filteredRows.length > 0 && table.filteredRows[0] && table.filteredRows[0].children) {
                this.filteredDatas = table.filteredRows[0].children;
                this.showChart();
              } else {
                this.filteredDatas = this.contractDatas;
              }
            })
          }
        })
      },
      substitute(guid) {
        this.selectedFrsGuid = guid;
      },
      toggleActiveLegend(index) { // On sélectionne/dé-sélectionne un statut
        this.activeLegend = [...this.activeLegend.slice(0, index), !this.activeLegend[index], ...this.activeLegend.slice(index + 1)]
      },
      showChart() {
        const canvas = document.getElementById("contract-chart");
        if (this.chart) this.chart.destroy();

        // Récupération des données pour afficher le graphique
        const data = this.filteredDatas.reduce((acc, row) => {
          acc[row.ContractStatus - 1] += 1;
          return acc;
        }, [0, 0, 0])

        this.chart = new Chart(canvas, {
          type: 'doughnut',
          data: {
            labels: ['A faire', 'En cours', 'Terminé'],
            datasets: [
              {
                data,
                backgroundColor: ['#D32F2F', '#FFC107', '#388E3C', '#50E3C2'],
              },
            ],
          },
          options: {
            legend: {
              display: false
            },
            cutoutPercentage: 80,
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  return " " + data.labels[tooltipItem.index] + " : " + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                }
              }
            },
            animation: {
              duration: 230
            }
          }
        });
      },
      formatNbPercent(n) {
        return n.toLocaleString("fr-FR", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 })
      },
    },
    computed: {
      contratShortcutUrl() {
        return getIntraRedirectUrl(encodeURIComponent("~/Pages/Commun/Drone.aspx?url=campaign-list"));
      },
      rows() {
        return this.contractDatas.filter(r => this.activeLegend[r.ContractStatus - 1])
      },
      columns() {
        const uniqFamilies = uniq(this.contractDatas.map(r => r.Family)).sort();
        const uniqSubFamilies = uniq(this.contractDatas.map(r => r.SubFamily)).sort();

        return [
          { label: "Code Intranet", field: "CodeIntra", filterOptions: { enabled: true, } },
          { label: "Code Compta", field: "CodeCompta", filterOptions: { enabled: true, } },
          { label: "Fournisseur", field: "Name", filterOptions: { enabled: true } },
          {
            label: "Famille", field: "Family", filterOptions: {
              enabled: true,
              placeholder: "Toutes",
              filterDropdownItems: uniqFamilies,
              //  filterFn: (data, filter) => {
              //    if (data.indexOf(filter) !== -1)
              //      return true;
              //    return false;
              //  }
            }
          },
          {
            label: "Sous Famille", field: "SubFamily", filterOptions: {
              enabled: true,
              placeholder: "Toutes",
              filterDropdownItems: uniqSubFamilies,
            }
          },
          { label: "Pays", field: "PaysRef", filterOptions: { enabled: true } },
          { label: "CDM", field: "Cdm", filterOptions: { enabled: true } },
          { label: "Statut", field: "ContractStatus", tdClass: "contract-status-container" },
        ]
      }
    }
  }
</script>

<style scoped>
  .shortcuts ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    column-gap: 14px;
    row-gap: 18px;
    flex-wrap: wrap;
  }

    .shortcuts ul li {
    }

      .shortcuts ul li a {
        display: flex;
        flex-direction: column;
        align-items: center;
        row-gap: 12px;
        text-decoration: none;
        color: inherit;
      }

  .shortcuts .icon-container {
    width: 62px;
    aspect-ratio: 1/1;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 0;
  }

    .shortcuts .icon-container .icon {
      color: white;
      font-size: 32px;
      line-height: 0;
    }

  .contract-container {
    display: grid;
    grid-template-columns: 340px 1fr;
    column-gap: 24px;
  }

  .bottom-container {
    display: grid;
    grid-template-columns: 1fr 340px;
    column-gap: 24px;
    margin-top: 24px;
  }

  .substitute {
    width: max-content;
  }

  .white-box {
    padding: 12px;
  }

  .summary h2,
  .details h2,
  .rubriques h2,
  .shortcuts h2 {
    font-size: 20px;
    border-left: 3px solid #A7C13C;
    padding-left: 4px;
  }

  .summary .chart {
    position: relative;
  }

    .summary .chart .total {
      position: absolute;
      top: 50%;
      left: 50%;
      line-height: 1;
      transform: translate(-50%, -50%);
      font-size: 64px;
      font-weight: bold;
    }

  .details .legend {
    display: flex;
    column-gap: 12px;
    margin: 24px 0;
  }

    .details .legend > div {
      padding: 8px 18px;
      color: white;
      background-color: #CCC;
      transition: all ease 230ms;
      border-radius: 6px;
    }

      .details .legend > div:hover {
        cursor: pointer;
        transform: scale(1.05);
      }

      .details .legend > div.active:nth-child(1) {
        background-color: #D32F2F;
      }

      .details .legend > div.active:nth-child(2) {
        background-color: #FFC107;
      }

      .details .legend > div.active:nth-child(3) {
        background-color: #388E3C;
      }

  .rubrique-tabs {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    column-gap: 1.5em;
    row-gap: 12px;
    margin-top: 24px;
    border-bottom: 1px solid #EEE;
  }

    .rubrique-tabs li {
      padding: 2px 0;
      font-size: 1.2em;
      transition: all ease 230ms;
      border-bottom: 1px solid transparent;
    }

      .rubrique-tabs li:hover {
        cursor: pointer;
      }

      .rubrique-tabs li.active {
        color: #7ED321;
        border-bottom-color: #7ED321;
      }

  .rubriques-details {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, 320px);
    column-gap: 1.5em;
    row-gap: 12px;
    margin-top: 24px;
  }

    .rubriques-details li {
      border-radius: 6px;
      text-align: center;
    }

      .rubriques-details li a {
        text-decoration: none;
        color: inherit;
        display: block;
        height: 100%;
        width: 100%;
        padding: 4px 16px;
      }

        .rubriques-details li a:hover {
          cursor: pointer;
        }

  .rubrique-document-list {
    margin: 0;
    padding: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 1em;
    list-style: none;
  }

    .rubrique-document-list li .doc-title {
      text-decoration: none;
    }

      .rubrique-document-list li .doc-title:hover {
        cursor: pointer;
      }


    .rubrique-document-list li small {
      display: flex;
      justify-content: space-between;
      font-size: 0.9em;
      color: #777;
    }
</style>

<style>
  .contract-status-circle-1,
  .contract-status-circle-2,
  .contract-status-circle-3 {
    display: block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: auto;
  }

    .contract-status-circle-1.inline,
    .contract-status-circle-2.inline,
    .contract-status-circle-3.inline {
      display: inline-block;
      margin: 0;
      margin-right: 12px;
      margin-bottom: 6px;
      margin-top: 6px;
    }


  .contract-status-circle-1 {
    background-color: #D32F2F;
  }

  .contract-status-circle-2 {
    background-color: #FFC107;
  }

  .contract-status-circle-3 {
    background-color: #388E3C;
  }

  .contract-status-container {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Achat/DashboardCdm/Contrats.vue